package org.example.project

import org.example.project.client.config.ApiConfig

object WebApiConfigProvider {

    const val DEFAULT_PRODUCTION_API_URL = "https://api.animacyjna.boyo.pl"
    const val DEFAULT_LOCAL_DEV_API_URL = "http://localhost:8080"

    fun resolveApiConfig(
        queryParamProvider: (String) -> String? = { WebPlatformClient.getBrowserQueryParam(it) },
        metaTagProvider: (String) -> String? = { WebPlatformClient.getBrowserMetaTag(it) },
        browserOriginProvider: () -> String? = { WebPlatformClient.getBrowserOrigin() }
    ): ApiConfig {
        // 1. Manual query param override (?apiUrl=... or ?api=...)
        val queryApi = queryParamProvider("apiUrl")
            ?: queryParamProvider("api")

        if (!queryApi.isNullOrBlank()) {
            val trimmed = queryApi.trim()
            val isDevLoopback = isDevHost(trimmed)
            return ApiConfig(trimmed, allowInsecureHttp = isDevLoopback)
        }

        // 2. Local development origin (e.g. webpack dev server on 8081/8082 or local backend)
        val browserOrigin = browserOriginProvider()
        if (!browserOrigin.isNullOrBlank() && isDevHost(browserOrigin)) {
            val devUrl = if (browserOrigin.contains(":8080")) {
                browserOrigin
            } else {
                DEFAULT_LOCAL_DEV_API_URL
            }
            return ApiConfig(devUrl, allowInsecureHttp = true)
        }

        // 3. Runtime configuration via HTML meta tag (<meta name="api-url" content="...">)
        val metaApi = metaTagProvider("api-url")
            ?: metaTagProvider("api-base-url")
        if (!metaApi.isNullOrBlank()) {
            val trimmed = metaApi.trim()
            return ApiConfig(trimmed, allowInsecureHttp = isDevHost(trimmed))
        }

        // 4. Remote browser origin defaults to production API endpoint
        if (!browserOrigin.isNullOrBlank()) {
            return ApiConfig(DEFAULT_PRODUCTION_API_URL, allowInsecureHttp = false)
        }

        // 5. Default loopback fallback for offline / test environments without origin
        return ApiConfig(DEFAULT_LOCAL_DEV_API_URL, allowInsecureHttp = true)
    }

    private fun isDevHost(url: String): Boolean {
        val lower = url.lowercase().trim()
        return lower.startsWith("http://localhost") ||
            lower.startsWith("http://127.0.0.1") ||
            lower.startsWith("http://::1") ||
            lower.startsWith("http://[::1]") ||
            lower.startsWith("http://10.0.2.2")
    }
}
